import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api/api/api.service';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToasterService } from '../services/toaster/toaster.service';
import { AuthService, IUser } from '../auth/auth.service';
import vimeoPlayer from '@vimeo/player';

// TODO: clean this component to make it more generic or less generic with component specific elements inside the component
interface IItems {
  url: [0];
  name: number;
  _id: any;
  email?: string;
  character?: string;
  companyId: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  company_name: string;
}
@Component({
  selector: 'app-shared-table',
  templateUrl: './shared-table.component.html',
  styleUrls: ['./shared-table.component.scss'],
})
export class SharedTableComponent implements OnInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();

  @Input() items: IItems[] = [];
  @Input() maxCount: number;
  @Input() countToShow = 50;
  @Input() showButtons = ['edit', 'clone', 'delete'];
  skip = 0;

  @Input()
  reportBtn = false;

  @Input() isType: string;
  @Output() itemEdit = new EventEmitter<TEditData>();
  @Output() itemDelete = new EventEmitter();
  @Output() itemClone = new EventEmitter();
  @Output() loadPageData = new EventEmitter<any>();
  // @Output() previous = new EventEmitter();
  @Output() upload = new EventEmitter();

  @Output()
  downloadReportEvent = new EventEmitter();

  @Output()
  searchEvent = new EventEmitter<string>();

  @Output()
  playersBtnEvent = new EventEmitter<any>();

  modalRef: NgbModalRef = null;

  previewURL: any;
  loadingPdf = false;
  videoTitle = null;
  currentUser: IUser = null;
  excludeTypes = [
    'Sequence',
    'Jumble',
    'User',
    'Company',
    'Division',
    'Questions',
    'Branches',
    'Order',
    'Questions-Game',
    'Mario-Game',
    'Packing-Game',
    'Jumbles-Game',
    'Orderings-Game',
    'SJT-Game',
    'Classifications-Game',
    'Master-Game',
    'Master Game Order',
    'Character',
    'Image',
    'MTC-Game',
    'MTC-Game',
    'Mini-Game',
    'Password-Game',
    'Values-Game',
    'Feedback',
    'Aptitude-Game',
    'Wheel-Game',
    'Monopoly',
    'LemonadePlayer',
  ];
  newTypes = ['Learning-Game', 'Angry-Bird-Game', 'Slider-Game'];
  searchForm: FormGroup = this._formBuilder.group({
    searchCtrl: new FormControl(''),
  });
  uploading = false;

  widthName = 33;
  widthIndex = 33;
  currentPage = 1;
  tempFileUrl = { type: '', url: '' };
  searchTerm = '';
  // count=50;
  form: UntypedFormGroup = this._formBuilder.group({
    name: ['', [Validators.required]],
    url: ['', [Validators.required]],
    email: [null],
    _id: [null],
  });
  // we need to store this as we need to use it later when we want to delete the previous file
  previousUrl: '';
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _api: ApiService,
    private _modalService: NgbModal,
    private _toast: ToasterService,
    private _authService: AuthService,
  ) {}

  ngOnInit(): void {
    // console.log(this.isType);
    this.currentUser = this._authService.currentUserValue;

    this.searchForm.controls.searchCtrl.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        takeUntil(this._unsubscribe$),
      )
      .subscribe((val) => {
        if (this.newTypes.includes(this.isType)) {
          this.searchEvent.emit(val);
        } else {
          this.onSearchChange(val);
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
    if (this.isType) {
      this.widthName = 30;
      this.widthIndex = 20;
    }
  }

  isNotCurrentUser(element): boolean {
    if (this.isType === 'User' && element._id === this.currentUser._id) {
      return false;
    }

    return true;
  }

  ecModal(customContent, index, type?, item?: any): void {
    if (this.newTypes.includes(this.isType)) {
      if (type === 'e') {
        this.itemEdit.emit(item);
      } else if (type === 'c') {
        this.itemClone.emit(item);
      } else if (type === 'd') {
        this.form.controls.name.setValue(item.name);
        this.form.controls._id.setValue(item._id);

        this.modalRef = this._modalService.open(customContent, {
          windowClass: 'dark-modal',
          backdrop: 'static',
          size: 'lg',
        });
      }
    } else if (this.excludeTypes.includes(this.isType)) {
      if (type === 'e') {
        this.itemEdit.emit(index);
      } else if (type === 'c') {
        this.itemClone.emit(index);
      } else if (type === 'd') {
        if (this.isType === 'User') {
          this.form.controls.email.setValue(this.items[index].email);
        } else {
          this.form.controls.name.setValue(
            this.items[index].name || this.items[index]?.character,
          );
        }

        this.form.controls._id.setValue(this.items[index]._id);
        this.modalRef = this._modalService.open(customContent, {
          windowClass: 'dark-modal',
          backdrop: 'static',
          size: 'lg',
        });
        // this.itemDelete.emit(this.items[index]._id);
      }
    } else {
      this.form.reset();
      const url =
        this.isType === 'Music' ||
        this.isType === 'Voices' ||
        this.isType === 'Video' ||
        this.isType === 'File' ||
        this.isType === 'Pdf'
          ? this.items[index].url
          : this.items[index].url[0];
      this.form.controls.url.setValue(url);
      this.form.controls.name.setValue(this.items[index].name);
      this.form.controls._id.setValue(this.items[index]._id);
      this.previewURL = this.isType === 'Video' ? null : url;
      this.previousUrl = this.previewURL;
      this.modalRef = this._modalService.open(customContent, {
        windowClass: 'dark-modal',
        backdrop: 'static',
        size: 'lg',
      });
    }
  }

  editItem(): void {
    const data = {
      name: this.form.value.name,
      url: [],
      _id: this.form.value._id,
      previousUrl: this.previousUrl,
    };
    data.url.push(this.form.value.url);
    this.itemEdit.emit(data);
    // now we will clear the temp file data
    this.tempFileUrl.type = '';
    this.tempFileUrl.url = '';
  }

  deleteItem(): void {
    const data =
      this.isType === 'User'
        ? { email: this.form.value.email, _id: this.form.value._id }
        : { name: this.form.value.name, _id: this.form.value._id };
    // console.log(data);
    this.itemDelete.emit(data);
  }

  cloneItem(): void {
    // console.log('clone data');
    // this.itemClone.emit({item:item,index:index})
    const data = { name: this.form.value.name, url: [] };
    data.url.push(this.form.value.url);
    this.itemClone.emit(data);
  }

  uploadItem(dataInput): void {
    this.uploading = true;
    if (this.isType === 'Character') {
      this.deleteCharacterFile();
      const formData = new FormData();
      formData.append('character', dataInput.data);
      this._api
        .uploadCharector(formData)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (data) => {
            this._toast.showSuccess('Character uploaded successfully');
            // console.log(data);
            const url = data[0];
            this.form.controls.url.setValue(url);
            this.previewURL = data[0];
            // console.log(url);
            this.hideUpload();
          },
          (err) => {
            this._toast.showError(err.error.message);
            this.hideUpload();
          },
        );
    } else if (this.isType === 'Image') {
      this.deleteImageFile();
      const formData = new FormData();
      formData.append('background', dataInput.data);
      this._api
        .uploadImages(formData)
        .pipe(takeUntil(this._unsubscribe$))

        .subscribe(
          (data) => {
            this._toast.showSuccess('Image uploaded successfully');
            // console.log(data);
            const url = data[0];
            this.form.controls.url.setValue(url);
            this.previewURL = data[0];
            // console.log(url);
            this.hideUpload();
          },
          (err) => {
            this._toast.showError(err.error.message);
            this.hideUpload();
          },
        );
    } else if (this.isType === 'Music') {
      // this.deleteMusicFile();
      const formData = new FormData();
      formData.append('file', dataInput.data);
      this._api
        .uploadMusic(formData)
        .pipe(takeUntil(this._unsubscribe$))

        .subscribe(
          (data: string) => {
            this._toast.showSuccess('Music uploaded successfully');
            // console.log(data);
            const url = data;
            this.tempFileUrl.type = 'Music';
            this.tempFileUrl.url = url;
            this.form.controls.url.setValue(url);
            this.previewURL = data;
            // console.log(url);
            this.hideUpload();
          },
          (err) => {
            this._toast.showError(err.error.message);
            this.hideUpload();
          },
        );
    } else if (this.isType === 'Voices') {
      // this.deleteVoiceFile();
      const formData = new FormData();
      formData.append('file', dataInput.data);
      this._api
        .uploadVoices(formData)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (data: string) => {
            this._toast.showSuccess('Voice uploaded successfully');
            // console.log(data);
            const url = data;
            this.tempFileUrl.type = 'Voices';
            this.tempFileUrl.url = url;
            this.form.controls.url.setValue(url);
            this.previewURL = data;
            // console.log(url);
            this.hideUpload();
          },
          (err) => {
            this._toast.showError(err.error.message);
            this.hideUpload();
          },
        );
    } else if (this.isType === 'Pdf') {
      // this.deletePdfFile();
      const formData = new FormData();
      formData.append('file', dataInput.data);
      this._api
        .uploadPdf(formData)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (data: string) => {
            console.log('data: ', data);
            this._toast.showSuccess('Pdf uploaded successfully');
            // console.log(data);
            const url = data;
            this.tempFileUrl.type = 'Pdf';
            this.tempFileUrl.url = url;
            this.form.controls.url.setValue(url);
            this.previewURL = data;
            // console.log(url);
            this.hideUpload();
          },
          (err) => {
            console.log('err: ', err);
            this._toast.showError(err.error.message);
            this.hideUpload();
          },
        );
    }
  }

  deleteCharacterFile(): void {
    if (this.previewURL) {
      const formInput = { url: this.previewURL };
      this._api
        .deleteCharectorsImg(formInput)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (): void => {
            this._toast.showSuccess(
              'Previous character image removed successfully',
            );
          },
          (err) => {
            this._toast.showError(err.error.message);
          },
        );
    }
  }
  fileUploaded(url: string): void {
    this.form.patchValue({ url: url });
  }
  deleteImageFile(): void {
    if (this.previewURL) {
      const formInput = { url: this.previewURL };
      this._api
        .deleteImagesImg(formInput)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (): void => {
            this._toast.showSuccess('Previous image file removed successfully');
          },
          (err) => {
            this._toast.showError(err.error.message);
          },
        );
    }
  }

  deleteMusicFile(): void {
    if (this.previewURL) {
      const formInput = { url: this.previewURL };
      this._api
        .deleteMusicfile(formInput)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (): void => {
            this._toast.showSuccess('Previous music file removed successfully');
          },
          (err) => {
            this._toast.showError(err.error.message);
          },
        );
    }
  }

  deleteVoiceFile(): void {
    if (this.previewURL) {
      const formInput = { url: this.previewURL };
      this._api
        .deleteVoicefile(formInput)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (): void => {
            this._toast.showSuccess('Previous voice file removed successfully');
          },
          (err) => {
            this._toast.showError(err.error.message);
          },
        );
    }
  }

  deletePdfFile(): void {
    if (this.previewURL) {
      const formInput = { url: this.previewURL };
      this._api
        .deletePdfFile(formInput)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(
          (): void => {
            this._toast.showSuccess('Previous Pdf file removed successfully');
          },
          (err) => {
            this._toast.showError(err.error.message);
          },
        );
    }
  }

  loadPage(e, _search?): void {
    const index = e * this.countToShow - this.countToShow;
    const search = _search || this.searchTerm;
    this.loadPageData.emit({ index, countToShow: this.countToShow, search });
  }

  onSearchChange(e): void {
    this.skip = 0;
    this.items = [];
    this.searchTerm = e;
    // resetting the current page to 1
    this.currentPage = 1;
    this.loadPage('1', e);
  }

  hideUpload(): void {
    this.uploading = false;
    console.log('uploading: ', this.uploading);
  }

  showUploading(): void {
    this.uploading = true;
  }

  playVideo(modal, videoUrl): void {
    this.modalRef = this._modalService.open(modal, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
    const player = new vimeoPlayer('videoContainer', { url: videoUrl });
    player.setVolume(1);
    player.getVideoTitle().then((title) => {
      this.videoTitle = title;
    });
  }

  previewPdf(modal, pdfUrl): void {
    this.previewURL = pdfUrl;
    this.loadingPdf = true;
    this.modalRef = this._modalService.open(modal, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
  }

  pdfLoadedStopSpinner(): void {
    this.loadingPdf = false;
  }

  closeVideoModal(): void {
    this.videoTitle = null;
  }

  onUploadDialogClose(type: 'dismiss' | 'close'): void {
    // we will delete the temp uploaded file on dialog close
    if (this.tempFileUrl.url) {
      this.previewURL = this.tempFileUrl.url;

      if (this.tempFileUrl.type === 'Music') {
        this.deleteMusicFile();
      }

      if (this.tempFileUrl.type === 'Voices') {
        this.deleteVoiceFile();
      }

      if (this.tempFileUrl.type === 'Pdf') {
        this.deletePdfFile();
      }
    }

    // now we will clear the temp file data
    this.tempFileUrl.type = '';
    this.tempFileUrl.url = '';

    if (this.modalRef) {
      if (type === 'close') {
        this.modalRef.close();
      } else {
        this.modalRef.dismiss();
      }
    }
  }

  public downloadReport(item): void {
    this.downloadReportEvent.emit(item);
  }

  clickPlayersBtn(item: any): void {
    console.log('Event: ', item);
    this.playersBtnEvent.emit(item);
  }
}

export interface TEditData {
  name: string;
  url: string[];
  _id: string;
  previousUrl: string;
}
